import React from 'react';
import { clsx } from 'clsx';

// LR-498: the left-rail segmented control that flips the master pane between the two views —
// "By date" (a chronological blotter across all counterparties) and "By counterparty" (one CP's
// full history). It owns nothing; the host writes `hview` to the URL on change.

export type HistoryView = 'date' | 'cp';

const SEGMENTS: { value: HistoryView; label: string }[] = [
  { value: 'date', label: 'By date' },
  { value: 'cp', label: 'By counterparty' },
];

export interface HistoryViewToggleProps {
  value: HistoryView;
  onChange: (value: HistoryView) => void;
}

export const HistoryViewToggle: React.FC<HistoryViewToggleProps> = ({ value, onChange }) => (
  // A two-option toggle, not a tab pattern: there is no associated tabpanel, so the simpler
  // aria-pressed idiom (mirroring DetailHeader's currency switcher) is the honest semantics.
  <div className="flex rounded-[7px] bg-lr-bg p-0.5" role="group" aria-label="History view">
    {SEGMENTS.map((seg) => {
      const active = seg.value === value;
      return (
        <button
          key={seg.value}
          type="button"
          aria-pressed={active}
          onClick={() => onChange(seg.value)}
          className={clsx(
            'flex-1 rounded-[5px] py-[5px] text-center text-xs transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-lr-accent',
            active
              ? 'bg-lr-surface font-semibold text-lr-fg shadow-[0_1px_2px_rgba(0,0,0,.06)]'
              : 'font-medium text-lr-muted hover:text-lr-fg-2'
          )}
        >
          {seg.label}
        </button>
      );
    })}
  </div>
);
